<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>
  
  <script>
import * as echarts from 'echarts';
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '400px',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },

    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
      sidebarElm: null,
      chartData: {
        visitsData: [],
        ipData: [],
      },
      weekDays: [],
    };
  },
  mounted() {
    this.initChart();

    if (this.autoResize) {
      this.__resizeHandler = this._.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHandler);
    }

    // 监听侧边栏的变化
    this.sidebarElm = document.getElementsByClassName('sidebar-container')[0];
    this.sidebarElm && this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler);
    }

    this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler);

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.__resizeHandler();
      }
    },
    setOptions() {
      this.chart.setOption(
        {
          series: [
            {
              type: 'treemap',
              roam: false,
               nodeClick: false,
              data: this.data,
              data: this.data,
                 top:'10px',
              bottom:'20px',
              breadcrumb: {
                show: false,
              },
              label: {
                overflow: 'break',
                lineHeight: 20,
                position: "inside",
                distance:5,
                formatter: function (value, index) {
                  return `{a|${value.value}次\n${value.name} }`
                },
                rich: {
                  a: {
                    fontSize:14,
                    align:'center',
                    verticalAlign:'middle',
                  },
                },
              },
            },
          ],
        },
        true
      );
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions();
    },
  },
  watch: {
    data: {
      deep: true,
      handler(newvalue, oldvalue) {
        if (newvalue) {
          this.initChart();
        }
      },
    },
  },
};
</script>
  